import { Directive, ElementRef, HostListener, Input } from '@angular/core';

const DEFAULT_IMG = 'assets/img/image_default.png';

@Directive({
  selector: 'img[fallimg]'
})
export class FallimgDirective {
  @Input() fallback: string = DEFAULT_IMG;

  constructor(private el: ElementRef<HTMLImageElement>) {}

  @HostListener('error')
  onError(): void {
    const img = this.el.nativeElement;
    if (img.src !== window.location.origin + '/' + this.fallback) {
      img.src = this.fallback;
    }
  }
}
